import mitt from 'mitt';

const EventFactory = () => () => mitt();
export default EventFactory;



// WEBPACK FOOTER //
// ./src/services/EventFactory.js